export enum TableStatusEnum {
  UPCOMING = 'UPCOMING',
  FREE = 'FREE',
  SEATED = 'SEATED',
  CONFLICT = 'CONFLICT',
  LATE_BOOKING = 'LATE_BOOKING',
  BLOCKOUT_BY_TABLE_NON_SELECTED = 'BLOCKOUT_BY_TABLE_NON_SELECTED',
  BLOCKOUT_BY_TABLE_SELECTED = 'BLOCKOUT_BY_TABLE_SELECTED',
  PARTIALLY_SEATED = 'PARTIALLY_SEATED',
  WAITING_AT_BAR = 'WAITING_AT_BAR',
  BILL_WITH_CUSTOMER = 'BILL_WITH_CUSTOMER',
  OVERTIME = 'OVERTIME',
  PAID = 'PAID',
  CLEAR_TABLE = 'CLEAR_TABLE'
}

export const FloorplanColors = {
  PartiallySeated: {
    Primary: 0xCA388A,
    Secondary: 0xFCF3F9,
  },
  WaitingAtBar: {
    Primary: 0xD6A2E8,
    Secondary: 0xFBF6FD,
  },
  BillWithCustomer: {
    Primary: 0x3B3B98,
    Secondary: 0xF0F4FD,
  },
  Overtime: {
    Primary: 0xff0000,
    Secondary: 0xfff0f0,
  },
  Paid: {
    Primary: 0x069574,
    Secondary: 0xecfdf6,
  },
  ClearTable: {
    Primary: 0xDFDFDF,
    Secondary: 0xFFFFFF,
  },
  Conflict: {
    Primary: 0xff0000,
    Secondary: 0xffc0be,
  },
  Upcoming: {
    Primary: 0xE58E26,
    Secondary: 0xFFF5E2,
  },
  Seat: {
    Primary: 0x992662,
    Secondary: 0xfff7fb,
  },
  BlockoutByTableNonSelected: {
    Primary: 0xdfdfdf,
    Secondary: 0xffffff,
  },
  BlockoutByTableSelected: {
    Primary: 0x992662,
    Secondary: 0xfff7fb,
  },
  Late: {
    Primary: 0xFF0000,
    Secondary: 0xFFF0F0,
    Chair: 0X992662,
  },
  Default: {
    Primary: 0x87c93d,
    Secondary: 0xf4fbea,
  },
};
